import React from 'react'

export default function SelectorInput({label, options, disabled, value, onChange}) {
  return (
    <div class="w-full my-3">
        <label className="block text-gray-700 text-sm mb-2 capitalize" for="bio">
           {label}
        </label>
                <div className="relative">
                <select value={value} onChange={onChange} disabled={disabled} className="flex w-full items-center shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
                leading-tight focus:outline-none focus:shadow-outline" id="grid-state">
                {options.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                ))}
                </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        </div>
    </div>
  )
}
